import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// react-snap writes the rendered DOM back into the static HTML at build time.
// When that markup is present we must hydrate it — calling createRoot would
// throw it away and re-render from scratch, losing the whole point of
// prerendering. On a cold container (dev server, or a build without the
// snapshot) fall back to a normal client render.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}
